var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLockImageSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.2879 34.8122V45.6259C87.2879 48.0112 85.3542 49.9449 82.9689 49.9449C80.5836 49.9449 78.65 48.0112 78.65 45.6259V38.1073C78.6517 36.5089 78.5636 34.9117 78.3858 33.3232C77.007 21.1967 70.2184 11.5241 57.2351 11.5241C50.7 11.5241 45.6906 14.0245 42.1674 18.093C41.8001 18.5169 41.4488 18.9583 41.1135 19.4174C38.0593 23.5926 36.3401 29.1021 35.9163 35.1385C35.8456 36.1147 35.8139 37.1064 35.8139 38.1051V49.9427H27.1816V34.8122C27.1816 25.9907 30.6823 17.9878 36.297 12.2601C41.7012 6.74707 49.0627 3.34108 57.1496 3.34108H57.3184C73.8115 3.34108 87.2879 17.504 87.2879 34.8122Z",
    fill: "url(#paint0_linear_111_12776)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.207 77.4251V79.8585C103.207 92.1439 97.0839 102.998 87.7235 109.536C86.4961 110.395 85.2163 111.176 83.8916 111.875C83.8026 111.922 83.715 111.967 83.6267 112.016C78.4964 114.67 72.8034 116.05 67.0276 116.042H49.9221C29.9411 116.042 13.7461 99.8466 13.7461 79.8656V77.4322C13.7461 76.239 13.8031 75.0594 13.917 73.8934C14.8798 63.9785 19.8468 55.2326 27.18 49.2979C27.4503 49.078 27.7239 48.8628 28.0008 48.6523C28.9865 47.8996 30.0107 47.1987 31.0691 46.5523C31.3145 46.4012 31.5615 46.2535 31.8101 46.1094C37.3127 42.9195 43.5618 41.2433 49.9221 41.2512H67.0305C69.3367 41.2502 71.6377 41.4687 73.9025 41.9039C78.6941 42.8267 83.2481 44.7141 87.2877 47.4515C95.9757 53.3332 101.968 62.8914 103.036 73.8899C103.149 75.0516 103.206 76.23 103.207 77.4251Z",
    fill: "url(#paint1_linear_111_12776)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M62.6441 116.035H49.9229C29.9418 116.035 13.7461 99.8403 13.7461 79.8585V77.4252C13.7461 76.2314 13.8033 75.0519 13.9177 73.8864C14.9158 63.6056 20.2183 54.5827 28.0008 48.6459C34.2965 43.8376 42.0017 41.2386 49.9236 41.2512H59.9473C55.6682 43.6486 51.6407 46.7734 51.1258 51.4897C50.2831 59.2241 59.955 61.4555 62.0585 72.0442C64.8521 86.1266 49.9659 93.4302 52.4381 104.842C53.5669 110.049 57.7421 113.477 62.6441 116.035Z",
    fill: "url(#paint2_linear_111_12776)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M103.209 77.425V79.8583C103.209 93.75 95.3805 105.812 83.8933 111.874C85.1944 110.673 86.5067 109.282 87.6411 107.679C97.3625 93.9011 92.5552 65.6383 76.9273 53.4545C61.2833 41.2574 43.4742 45.2553 31.8125 46.1015C37.3154 42.9131 43.5646 41.2388 49.9246 41.2489H67.0315C85.8202 41.2489 101.26 55.5708 103.037 73.8869C103.151 75.051 103.208 76.2303 103.209 77.425Z",
    fill: "url(#paint3_linear_111_12776)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7293 116.035H49.9229C29.9418 116.035 13.7461 99.8401 13.7461 79.8584V77.425C13.7461 76.2313 13.8033 75.0517 13.9177 73.8862C14.9158 63.6054 20.2183 54.5826 28.0008 48.6458C22.0315 62.5734 20.7339 85.1044 28.3681 99.2263C35.8292 113.027 48.2057 115.13 53.7293 116.035Z",
    fill: "url(#paint4_linear_111_12776)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7173 92.5054C66.7986 92.8359 66.8037 93.1805 66.7322 93.5132C66.6606 93.8459 66.5144 94.158 66.3044 94.4258C66.0945 94.6937 65.8264 94.9103 65.5204 95.0592C65.2144 95.2082 64.8786 95.2856 64.5382 95.2856H52.1984C51.8581 95.2856 51.5223 95.2082 51.2163 95.0592C50.9103 94.9103 50.6422 94.6937 50.4323 94.4258C50.2223 94.158 50.076 93.8459 50.0045 93.5132C49.933 93.1805 49.9381 92.8359 50.0194 92.5054L53.0884 80.0236C53.1865 79.6264 53.174 79.2099 53.0522 78.8193C52.9304 78.4287 52.7041 78.0789 52.3976 77.8078C51.4087 76.9387 50.6222 75.8634 50.0937 74.6576C49.5651 73.4517 49.3073 72.1447 49.3385 70.8285C49.4402 66.1518 53.14 62.3361 57.7489 62.0204C57.9325 62.0069 58.1176 61.9999 58.3033 61.9985C60.145 61.9852 61.9466 62.5352 63.4669 63.5748C64.9871 64.6143 66.1533 66.0937 66.809 67.8147C67.4648 69.5357 67.5788 71.416 67.1358 73.2036C66.6928 74.9912 65.714 76.6007 64.3306 77.8163C64.026 78.0868 63.8014 78.4355 63.6811 78.8247C63.5609 79.2138 63.5495 79.6285 63.6483 80.0236L66.7173 92.5054Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0876 80.0236L50.0185 92.5054C49.9372 92.8359 49.9321 93.1805 50.0037 93.5132C50.0752 93.8459 50.2215 94.158 50.4314 94.4258C50.6413 94.6937 50.9094 94.9103 51.2154 95.0592C51.5214 95.2082 51.8573 95.2856 52.1976 95.2856H50.9608C50.6205 95.2856 50.2846 95.2082 49.9786 95.0592C49.6726 94.9103 49.4045 94.6937 49.1946 94.4258C48.9847 94.158 48.8384 93.8459 48.7669 93.5132C48.6953 93.1805 48.7004 92.8359 48.7817 92.5054L51.8515 80.0236C51.9493 79.6263 51.9365 79.2098 51.8145 78.8192C51.6925 78.4286 51.4659 78.0788 51.1593 77.8078C50.1707 76.9384 49.3845 75.863 48.856 74.6573C48.3275 73.4515 48.0695 72.1446 48.1001 70.8285C48.206 65.966 52.2011 62.0331 57.0657 61.9992C57.2967 61.9992 57.5241 62.0048 57.7502 62.0211C53.1413 62.3368 49.4414 66.1525 49.3397 70.8292C49.3086 72.1454 49.5664 73.4524 50.0949 74.6583C50.6235 75.8641 51.4099 76.9394 52.3989 77.8085C52.7048 78.0798 52.9307 78.4296 53.0521 78.82C53.1735 79.2105 53.1858 79.6267 53.0876 80.0236Z",
    fill: "url(#paint5_linear_111_12776)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M27.1823 40.1472C29.8062 37.845 32.7494 35.9345 35.9205 34.4753C35.8527 35.4514 35.8188 36.4403 35.8188 37.4419V44.0321C32.8611 45.4034 29.666 47.1685 27.1816 49.2795L27.1823 40.1472Z",
    fill: "url(#paint6_linear_111_12776)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_111_12776",
    x1: 57.2351,
    y1: 47.5172,
    x2: 57.2351,
    y2: 4.12583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_111_12776",
    x1: 58.4766,
    y1: 116.198,
    x2: 58.4766,
    y2: 35.8604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_111_12776",
    x1: -9.05252,
    y1: 78.6422,
    x2: 53.9553,
    y2: 78.6422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FEFEFC",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FEFEFC",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FEFEFD",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FFFFFE",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_111_12776",
    x1: 97.7552,
    y1: 92.2525,
    x2: 26.5778,
    y2: 14.1868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4B9BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_111_12776",
    x1: 17.2538,
    y1: 62.3997,
    x2: 60.7956,
    y2: 141.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#D7DBDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C3C9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4BCBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_111_12776",
    x1: 52.5027,
    y1: 59.8766,
    x2: 54.0334,
    y2: 97.0465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4B9BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_111_12776",
    x1: 31.5511,
    y1: 31.604,
    x2: 31.5511,
    y2: 48.7208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4B9BE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLockImageSimple);
export default __webpack_public_path__ + "static/media/ic-lock-image-simple.9d873e8a99248a2beb4119b781ac23f5.svg";
export { ForwardRef as ReactComponent };